import * as React from "react";
import LayoutGrid from "@tunnel-components/layouts/layout/index";
import BreadCrumb from "@tunnel-components/@sharded/widgets/breadcrumb/component";
import * as Utils from "@Cyclope-Utils/index";
import * as Enums from "@tunnel-enums/index";
import * as Paths from "@tunnel-enums/index";
import * as Lodash from "lodash";
import BoxGrid from "@tunnel-components/@sharded/widgets/box/custom/component";
import MessageEmptyIncidents from "@tunnel-components/@sharded/message/component";

import * as i18next from "i18next";
// import * as cx from 'classnames';

import SupervisionIncident from "@tunnel-components/@sharded/@widgets/supervision/incidents/component";

/**
 * @function Component : Composant fonctionnel
 * @description : fonction simple qui prend en argument un objet props
 * et rend du contenu sous forme d'élement  JSX
 * @param { ComponentInterface } props
 * @returns { JSX.Element }
 * @implements { ComponentInterface }
 * @type { React.FunctionComponent }
 * @infos "https://reactjs.org"
 */
const Component: React.FunctionComponent<any> = (props: any): JSX.Element => {
  /**
   * @affectation
   * @description :
   * Affectation par décomposition des élements de l'objet (props)
   * les élements existent ou sont créés dans ( ou par) la @class container
   * fonctions , méthodes, variables , objets, tableaux ...., sont les éléments
   * susceptibles de subir une affectation par décomposition
   * exemple : const { elements } = objet ;
   * @infos "https://developer.mozilla.org"
   */
  const {
    onChangeIncident,
    onChangeDuration,
    onChangeSpeed,
    onChangeElement,
    checked,
    minDuration,
    maxSpeed,
    nbElement,
    incidentTypes,
    checkedCONGESTIONError,
    checkedSLOWError,
    checkedSTOPPEDError9,
    checkedSTOPPEDError7,
    checkedSTOPPEDError1,
    checkedSTOPPEDError5,
    loading,
    btnloading,
    errorserver,
    onSubmit,
    success,
  } = props;

  /**
   * Triage dans un tableau par ordre
   * @method onSortDynamic
   * @param { any[] }  Elem
   * @return { any []}
   * @infos "https://reactjs.org"
   */
  const onSortDynamic = (Elem: any): any => {
    {
      /** vérification de l'existence de l'élement  */
    }
    if (Lodash.isArray(Elem)) {
      return Elem.sort((a: any, b: any) =>
        a.label.toUpperCase() > b.label.toUpperCase()
          ? 1
          : b.label.toUpperCase() > a.label.toUpperCase()
          ? -1
          : 0
      );
    }
  };
  // const dataIncidentType: any = incidentTypes &&
  /**
   * @description : retourne un objet ( utilisateur )
   * @const
   * @name User
   * @type { any  }
   */
  const User: any = Utils.createdUserRoles();
  /**
   * @description : retourne un boolean
   * @const
   * @name authorization
   * @type { boolean  }
   */
  const authorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INCIDENTUPDATEINHIBITION,
  ]);
  const paramauthorization: boolean = Utils.simpleAuthorizationIsAllowed(User, [
    Enums.AuthorizationRightsEnums.INCIDENTSETTINGSRULES,
  ]);
  /**
   * @description : retourne un boolean ( )
   * @const
   * @name siteLoading
   * @type { boolean  }
   */
  const siteLoading: boolean =
    !Lodash.isUndefined(incidentTypes) &&
    !Lodash.isEmpty(incidentTypes) &&
    !Lodash.isNull(incidentTypes);

  /**
   * @expression return()
   * @description :
   * Cette expression transforme un élément JSX en élément HTML
   * @external
   * @name lodash
   * @infos "https://reactjs.org"
   */
  return (
    <LayoutGrid
      snackbar={success}
      someTextSuccees={i18next.t("les parametres ont ete modifies")}
      error={errorserver}
      btnloading={btnloading}
      loading={loading}
    >
      {!siteLoading && (
        <MessageEmptyIncidents message={i18next.t("espace non authoriser")} />
      )}
      {siteLoading && (
        <section className="tunnel-site animated fadeIn ">
          <BreadCrumb
            iconSupervision={true}
            links1={Paths.PathsNamesEnums.INCIDENTS}
            title={i18next.t("supervision")}
            breadText1={i18next.t("parametres incidents")}
          />
          <div className="contentAllSiteWithoutOnglet">
            <section className="columnsWithoutOnglet">
              <section className="content-wrapper">
                <section className="with-3-columns" id="columns">
                  <div className="incidentsTypes" style={{ width: "600px" }}>
                    {siteLoading && (
                      <BoxGrid
                        title={i18next.t("incidents")}
                        classNames="boderShadow"
                        error={!authorization && !paramauthorization}
                        onSubmit={onSubmit}
                        BtnTextSpan={i18next.t("enregistrer")}
                      >
                        <div className="incidentForm">
                          {incidentTypes &&
                            onSortDynamic(incidentTypes).map(
                              (elem: any, index: number) => {
                                return (
                                  <SupervisionIncident
                                    key={index}
                                    index={index}
                                    // value={elem.rule}
                                    // values={rules[index]}

                                    minDurations={minDuration[index]}
                                    maxSpeeds={maxSpeed[index]}
                                    nbElements={nbElement[index]}
                                    minDuration={elem.minDuration}
                                    maxSpeed={elem.maxSpeed}
                                    nbElement={elem.nbElement}
                                    incidentLabel={elem.label}
                                    labelIncident={i18next.t(`${elem.label}`)}
                                    id={elem.id}
                                    disabled={!checked[index]}
                                    authorization={authorization}
                                    checked={checked[index]}
                                    onChangeIncident={onChangeIncident(index)}
                                    nameInput={`${elem.label}`}
                                    // onChangeRules={onChangeRules(index)}
                                    onChangeDuration={onChangeDuration(index)}
                                    onChangeSpeed={onChangeSpeed(index)}
                                    onChangeElement={onChangeElement(index)}
                                    checkedCONGESTIONError={
                                      checkedCONGESTIONError
                                    }
                                    checkedSLOWError={checkedSLOWError}
                                    checkedSTOPPEDError9={checkedSTOPPEDError9}
                                    checkedSTOPPEDError5={checkedSTOPPEDError5}
                                    checkedSTOPPEDError7={checkedSTOPPEDError7}
                                    checkedSTOPPEDError1={checkedSTOPPEDError1}
                                    labelSTOPPEDError={i18next.t(
                                      "merci d'entrer un nombre compris entre 1 et 100"
                                    )}
                                    labelSTOPPEDError5={i18next.t(
                                      "merci d'entrer un nombre compris entre 1 et 7"
                                    )}
                                    labelSTOPPEDSecond={i18next.t("seconde(s)")}
                                    labelSTOPPEDFirst={i18next.t(
                                      "arrete plus de"
                                    )}
                                    labelSLOWError={i18next.t(
                                      "merci d'entrer un nombre compris entre 5 et 100"
                                    )}
                                    labelDureeminimal={i18next.t(
                                      "duree-minimale-incident"
                                    )}
                                    labelSLOWSecond={i18next.t("km/h")}
                                    labelSLOWFirst={i18next.t(
                                      "roulant a moins de"
                                    )}
                                    labelCONGESTIONError={i18next.t(
                                      "merci d'entrer un nombre compris entre 0 et 100"
                                    )}
                                    labelCONGESTIONSecond={i18next.t(
                                      "vehicule(s) lent(s) et/ou arrete(s)"
                                    )}
                                    labelCONGESTIONFirst={i18next.t("au moins")}
                                  />
                                );
                              }
                            )}
                        </div>
                      </BoxGrid>
                    )}
                  </div>
                </section>
              </section>
            </section>
          </div>
        </section>
      )}
    </LayoutGrid>
  );
};
Component.defaultProps = {
  incidentDuration: "",
};
/**
 * @interface ComponentInterface
 * @description :
 * Cette interface définit le model du props
 */
/*
interface ComponentInterface{

}*/

/**
 * @export
 */
export default React.memo(Component);



// WEBPACK FOOTER //
// ./src/apps/tunnel/components/@pages/supervision/incident/home/component.tsx